import React from "react"
import { FormControlLabel, Grid, Chip } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { Checkbox, CompletedByAvatar } from ".."
import { makeUpdateActionOptimisticResponse, useMutationResolveAction, useMutationUnresolveAction } from "../../data"
import { useAuth } from "../../services"
import { toId } from "../../utils"
import { RowBox } from "../Boxes"

const useCheckboxLabelStyles = makeStyles((theme) => ({
  label: {
    fontSize: 16,
    color: theme.palette.text.main,
  },
}))

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  confirmed: {
    fontSize: 13,
    fontWeight: "400",
    color: theme.palette.text.light,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  content: {
    marginBottom: theme.spacing(4),
  },
  sendingChip: {
    fontWeight: "600",
    color: "white",
    backgroundColor: theme.palette.primary.main,
  },
  unconfirmedChip: {
    fontWeight: "600",
    color: "white",
    backgroundColor: theme.palette.error.main,
  },
  confirmedChip: {
    fontWeight: "600",
    color: "white",
    backgroundColor: theme.palette.success.main,
  },
}))

const ActionResolve = ({ action }) => {
  const classes = useStyles()
  const { principal } = useAuth()
  const checkboxLabelClasses = useCheckboxLabelStyles()
  const [resolveAction, { loading: resolveLoading }] = useMutationResolveAction()
  const [unresolveAction, { loading: unresolveLoading }] = useMutationUnresolveAction()

  const resolved = Boolean(action.resolvedAt)

  const loading = resolveLoading || unresolveLoading

  const handleResolve = async () => {
    if (loading) return
    const newResolved = !resolved
    const optimisticResponse = makeUpdateActionOptimisticResponse({
      mutationName: newResolved ? "resolveAction" : "unresolveAction",
      action,
      principal,
    })
    const options = { variables: { id: toId(action) }, optimisticResponse }
    await (newResolved ? resolveAction(options) : unresolveAction(options))
  }

  return (
    <>
      <Grid container direction="row" alignItems="center" justifyContent="space-between" className={classes.root}>
        <Grid item xs={7}>
          <FormControlLabel
            classes={checkboxLabelClasses}
            label="Mark as resolved"
            control={<Checkbox color="primary" checked={resolved} onChange={handleResolve} />}
          />
        </Grid>
        <Grid item xs={5} container direction="row" alignItems="center" justifyContent="flex-end" spacing={1}>
          <Grid item>
            <RowBox>
              {resolved && <CompletedByAvatar at={action.resolvedAt} by={action.resolvedBy} mr={1} />}
              {!resolved && <Chip label="Unresolved" className={classes.unconfirmedChip} />}
              {resolved && <Chip label="Resolved" className={classes.confirmedChip} />}
            </RowBox>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export { ActionResolve }
